module.exports = __webpack_public_path__ + "static/media/Life.05f00f7d.svg";